import { useUser } from "../context/UserContext";
import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";

const AuthLayout = ({ children }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.accessToken) {
      navigate({ to: "/dashboard", resetScroll: true });
    }
  }, [user, navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      <main>
        {children}
      </main>
    </div>
  );
};

export default AuthLayout;
